// @flow

export default (url: string) => {
  // $FlowFixMe
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = url;
    script.onload = resolve;
    script.onerror = reject;
    if (document.body) {
      document.body.appendChild(script);
    }
  });
};
